import React from "react";
import "./Home.css";

export const Visa = () => {
  return (
    <div className="page-layout">
      <div className="text-layout">
        <h2>VISA Information</h2>
        <ol>
          <li className="visa-list">
            Visa invitation letters will be automatically provided upon
            registration. Once you have completed your registration and payment,
            an official invitation letter will be generated and sent to you.
            <br />
            <br />
            <span style={{ fontWeight: "bold" }}>
              IMPORTANT: Authors of accepted papers can request a visa
              invitation letter before registration. Please complete the form
              below and we will send a support letter to you as soon as
              possible.
            </span>
          </li>
          <li className="visa-list">
            Depending on your nationality, you may need more materials to apply
            for a VISA to Ireland. Please refer to the{" "}
            <a href="https://www.irishimmigration.ie/coming-to-work-in-ireland/what-are-my-options-for-working-in-ireland/coming-to-work-for-less-than-90-days/conference-event-visa/">
              Conference/Event VISA page
            </a>{" "}
            on the Irish Department of Justice website for detailed information
            on visa applications and requirements.
          </li>
          <li className="visa-list">
            You should also ensure to include a letter from your home university
            confirming any funding your institution is providing towards your
            journey.
          </li>
        </ol>
        <iframe
          width="640px"
          height="480px"
          src="https://forms.office.com/Pages/ResponsePage.aspx?id=pVz-Rm-GQk6S6e2HhiRVRa5yPDRH5J9NsOzJGeRG8E9UQ1I5VFhXMVJFOThNOThQUjhXUzhPWlg3Ty4u&embed=true"
          frameborder="0"
          marginwidth="0"
          marginheight="0"
          style={{ border: "none", maxWidth: "100%", maxheight: "100vh" }}
          allowfullscreen
          webkitallowfullscreen
          mozallowfullscreen
          msallowfullscreen
        >
          {" "}
        </iframe>
      </div>
    </div>
  );
};
